import get from 'lodash/get';
import { useMemo } from 'react';
import { usePreferences } from '../context/PreferencesContext';
import { useActiveSpectra } from './useActiveSpectra';
export default function useActiveSpectrumStyleOptions(id) {
    const activeSpectra = useActiveSpectra();
    const preferences = usePreferences();
    return useMemo(() => {
        const index = activeSpectra?.findIndex((activeSpectrum) => activeSpectrum.id === id);
        const isActive = !!(activeSpectra?.length === 0 || index !== -1);
        const opacity = isActive
            ? 1
            : get(preferences.current, 'general.dimmedSpectraOpacity', 0.1);
        return { isActive, opacity };
    }, [activeSpectra, id, preferences]);
}
